
export const associateResponseWithForm = (selector: string, instanceId: string, token: string) => {
    // This function is used to ensure the uniqueness of each form submission with global/singleton forms (i.e. a single form used in multiple places, such as events "notify me")
    // Each instance of the global form is associated with their responses by replacing a tokenised value in a hidden input within the form, with the id of the instance
    // This hidden input is a required form field in the backend form for this to work, otherwise all responses will be generic against the global form

    const root = document.querySelector(selector);
    if (!root) return;

    const hiddenInputs = root.querySelectorAll('form section input[type=hidden]') as unknown as HTMLInputElement[];
    if (!hiddenInputs || hiddenInputs.length === 0) return;

    for (const element of hiddenInputs) {
        if (element.value === token)
            element.value = instanceId;
    }
}
